import { render, staticRenderFns } from "./BrTargetCount.vue?vue&type=template&id=ef41b960&scoped=true"
import script from "./BrTargetCount.vue?vue&type=script&lang=js"
export * from "./BrTargetCount.vue?vue&type=script&lang=js"
import style0 from "./BrTargetCount.vue?vue&type=style&index=0&id=ef41b960&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef41b960",
  null
  
)

export default component.exports